module.exports = __webpack_public_path__ + "img/pdf.bde466e7.jpg";